module.exports = __webpack_public_path__ + "img/Ra.c6a82394.jpg";